import IdentityManager from '../services/identity/IdentityManagerFactory';

export const useIdentityManager = () => {
  return IdentityManager.getManager();
};
